<template>
  <div class="excellent-capabilities-call-test-list">
    <div class="port-display">
      <span>端口：</span>
      <span>{{ serverPort }}</span>
      <div class="actions">
        <slot name="actions"></slot>
      </div>
    </div>
    <el-row>
      <el-col
        v-for="(item, index) in data"
        :key="index"
        :span="item.span || span"
        :offset="item.offset"
        :pull="item.pull"
        :push="item.push"
        :class="item.className"
      >
        <div class="call-test-item">
          <div class="icon">
            <img :src="item.icon" alt="" />
          </div>
          <div class="right">
            <div class="title">
              <div class="label">{{ item.name }}</div>
              <el-button class="action" type="text" @click="item.click(item)">调用测试</el-button>
            </div>
            <div class="content">{{ `http://${serverIp}:${serverPort}${item.url}` }}</div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  name: 'CallTestList',
  components: {},
  props: {
    serverIp: {
      type: String,
      default: () => ''
    },
    serverPort: {
      type: Number,
      default: () => 0
    },
    data: {
      type: Array,
      default: () => {
        return []
      }
    },
    span: {
      type: Number,
      default: () => {
        return 8
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
@include theme(
  'excellent-capabilities-call-test-list',
  (
    --excellent-capabilities-call-test-list-port-display-background-color: #303c65,
    --excellent-capabilities-call-test-list-item-color: #fff,
    --excellent-capabilities-call-test-list-item-border-color: #29375b,
    --excellent-capabilities-call-test-list-item-label-color: #a5b3b9,
    --excellent-capabilities-call-test-list-item-action-color: #5aaad3
  ),
  (
    --excellent-capabilities-call-test-list-port-display-background-color:
      var(--base-color-notice-light-2),
    --excellent-capabilities-call-test-list-item-color: #192227,
    --excellent-capabilities-call-test-list-item-border-color: #ebebeb,
    --excellent-capabilities-call-test-list-item-label-color: #5a6973,
    --excellent-capabilities-call-test-list-item-action-color: #5aaad3
  )
);
.excellent-capabilities-call-test-list {
  @include adaptation(
    (
      --excellent-capabilities-call-test-list-port-display-height: 55px,
      --excellent-capabilities-call-test-list-port-display-padding: 16px,
      --excellent-capabilities-call-test-list-port-display-line-height: 23px,
      --excellent-capabilities-call-test-list-port-display-margin-bottom: 16px,
      --excellent-capabilities-call-test-list-port-display-font-size: 16px,
      --excellent-capabilities-call-test-list-port-actions-margin-left: 16px,
      --excellent-capabilities-call-test-list-content-frame-padding: 12px 16px,
      --excellent-capabilities-call-test-list-el-row-margin: 0 -12px,
      --excellent-capabilities-call-test-list-el-col-padding: 0 12px,
      --excellent-capabilities-call-test-list-item-font-size: 12px,
      --excellent-capabilities-call-test-list-item-margin-bottom: 16px,
      --excellent-capabilities-call-test-list-item-border-radius: 2px,
      --excellent-capabilities-call-test-list-item-border-width: 1px,
      --excellent-capabilities-call-test-list-item-padding: 22px 20px,
      --excellent-capabilities-call-test-list-item-min-height: 92px,
      --excellent-capabilities-call-test-list-item-icon-margin-right: 22px,
      --excellent-capabilities-call-test-list-item-icon-size: 30px,
      --excellent-capabilities-call-test-list-item-title-margin-bottom: 12px,
      --excellent-capabilities-call-test-list-item-title-line-height: 20px,
      --excellent-capabilities-call-test-list-item-label-font-size: 14px,
      --excellent-capabilities-call-test-list-item-action-margin-left: 12px
    )
  );

  .port-display {
    height: var(--excellent-capabilities-call-test-list-port-display-height);
    padding: var(--excellent-capabilities-call-test-list-port-display-padding);
    line-height: var(--excellent-capabilities-call-test-list-port-display-line-height);
    background-color: var(--excellent-capabilities-call-test-list-port-display-background-color);
    margin-bottom: var(--excellent-capabilities-call-test-list-port-display-margin-bottom);
    font-size: var(--excellent-capabilities-call-test-list-port-display-font-size);
    font-weight: 500;
    display: flex;
    align-items: center;
    color: var(--base-color-white);

    .actions {
      margin-left: var(--excellent-capabilities-call-test-list-port-actions-margin-left);
    }
  }

  .el-row {
    overflow: hidden;
    margin: var(--excellent-capabilities-call-test-list-el-row-margin);

    .el-col {
      padding: var(--excellent-capabilities-call-test-list-el-col-padding);

      .call-test-item {
        display: flex;
        align-items: center;
        min-height: var(--excellent-capabilities-call-test-list-item-min-height);
        height: var(--excellent-capabilities-call-test-list-item-min-height);
        padding: var(--excellent-capabilities-call-test-list-item-padding);
        color: var(--excellent-capabilities-call-test-list-item-color);
        font-size: var(--excellent-capabilities-call-test-list-item-font-size);
        border-radius: var(--excellent-capabilities-call-test-list-item-border-radius);
        border: var(--excellent-capabilities-call-test-list-item-border-width) solid
          var(--excellent-capabilities-call-test-list-item-border-color);
        margin-bottom: var(--excellent-capabilities-call-test-list-item-margin-bottom);

        .icon {
          margin-right: var(--excellent-capabilities-call-test-list-item-icon-margin-right);
          display: flex;
          align-items: center;

          img {
            width: var(--excellent-capabilities-call-test-list-item-icon-size);
            height: var(--excellent-capabilities-call-test-list-item-icon-size);
          }
        }

        .right {
          width: 100%;

          .title {
            display: flex;
            align-items: center;
            margin-bottom: var(--excellent-capabilities-call-test-list-item-title-margin-bottom);
            height: var(--excellent-capabilities-call-test-list-item-title-line-height);
            line-height: var(--excellent-capabilities-call-test-list-item-title-line-height);

            .label {
              font-size: var(--excellent-capabilities-call-test-list-item-label-font-size);
              color: var(--excellent-capabilities-call-test-list-item-label-color);
            }
            .action {
              color: var(--excellent-capabilities-call-test-list-item-action-color);
              margin-left: var(--excellent-capabilities-call-test-list-item-action-margin-left);
            }
          }

          .content {
            word-break: break-all;
          }
        }
      }
    }
  }
}
</style>
